import { Vue, Component, Watch } from 'vue-property-decorator'
import DocumentList from '@/components/dashboard/document/document-list/DocumentList.component.vue'
import DocumentFilter from '@/components/dashboard/document/document-filter/DocumentFilter.component.vue'
import DocumentDetail from '@/components/dashboard/document/document-detail/DocumentDetail.component.vue'
import DocumentEmail from '@/components/dashboard/document/document-email/DocumentEmail.component.vue'
import { Document, TableHeader } from '@/types'
import Axios from 'axios'
import * as R from 'ramda'

@Component({
  components: {
    DocumentList,
    DocumentFilter,
    DocumentDetail,
    DocumentEmail
  }
})
export default class DocumentPageComponent extends Vue {
  // #region data
  items: Document[] = []
  page: number = 1
  totalPage: number = 1
  counterDocuments: number = 0
  toggleFilter: boolean = false
  loadingData: boolean = false
  toggleEmail: boolean = false
  dataFilter: Object = {
    from: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().substr(0, 10),
    to: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toISOString().substr(0, 10)
  }
  options:boolean = false
  currentDocument:Document = {}
  loading: boolean = false
  toggleDetail: boolean = false
  documentDetails: DocumentDetail[] = []
  toggleErrorMessage:boolean = false
  itemsTotals = []
  headerTotals: TableHeader[] = [
    {
      text: 'Total General',
      value: 'title',
      sortable: false
    },
    {
      text: 'Gravado',
      value: 'taxedAmount',
      sortable: false
    },
    {
      text: 'Exonerado',
      value: 'exoneratedAmount',
      sortable: false
    },
    {
      text: 'I.G.V.',
      value: 'taxAmount',
      sortable: false
    },
    {
      text: 'Total',
      value: 'totalAmount',
      sortable: false
    }
  ]
  // #endregion

  @Watch('page')
  onChangePage (value:number, valueOld:number) {
    this.onLoadDocuments(this.dataFilter)
  }

  mounted () {
    this.onLoadDocuments({
      page: this.page,
      from: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().substr(0, 10),
      to: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toISOString().substr(0, 10)
    })
  }

  // #region methods
  onLoadDocuments (data: Object) {
    this.loadingData = true
    Axios.get('/documents', {
      params: {
        ...data,
        page: this.page
      }
    }).then(response => {
      this.itemsTotals = response.data.summary
      this.items = response.data.page.data
      this.totalPage = response.data.page.last_page
      this.counterDocuments = response.data.page.total
      this.loadingData = false
    }).catch(() => {
      this.loadingData = false
    })
  }

  onFilter (data:Object) {
    this.dataFilter = data
    this.onLoadDocuments(this.dataFilter)
  }
  // #endregion

  onDetailOptions (item: Document) {
    this.options = true
    this.currentDocument = item
  }

  printPDF () {
    if (R.equals(this.currentDocument.state, '0')) {
      this.options = false
      this.toggleErrorMessage = true
      return
    }

    const params = {
      voucherType: this.currentDocument.voucherType,
      voucherSerie: this.currentDocument.serieNumber,
      totalAmount: this.currentDocument.totalAmount,
      voucherNumber: this.currentDocument.documentNumber,
      dateIssue: this.currentDocument.dateIssue,
      token: JSON.parse(sessionStorage.getItem('token') as any).accessToken
    }

    const url = `${Axios.defaults.baseURL}/documents/print-pdf?${Object.entries(params).map(p => p.join('=')).join('&')}`
    const a = document.createElement('a')
    a.href = url
    this.options = false
    a.click()
  }

  onDownloadXML () {
    if (R.equals(this.currentDocument.state, '0')) {
      this.options = false
      this.toggleErrorMessage = true
      return
    }
    const params = {
      voucherType: this.currentDocument.voucherType,
      voucherSerie: this.currentDocument.serieNumber,
      totalAmount: this.currentDocument.totalAmount,
      voucherNumber: this.currentDocument.documentNumber,
      dateIssue: this.currentDocument.dateIssue,
      token: JSON.parse(sessionStorage.getItem('token') as any).accessToken
    }
    const a = document.createElement('a')
    const path = Object.entries(params).map((e) => e.join('=')).join('&')
    a.href = `${Axios.defaults.baseURL}/documents/xml?${path}`
    this.options = false
    a.click()
  }

  viewDetail () {
    this.loading = true
    Axios.get('/documents/detail', {
      params: {
        voucherType: this.currentDocument.voucherType,
        voucherSerie: this.currentDocument.serieNumber,
        totalAmount: this.currentDocument.totalAmount,
        voucherNumber: this.currentDocument.documentNumber,
        dateIssue: this.currentDocument.dateIssue
      }
    }).then(response => {
      this.toggleDetail = true
      this.loading = false
      this.documentDetails = response.data
    }).catch(() => {
      this.loading = false
      this.toggleDetail = false
    })
    this.options = false
  }

  onDownloadExcel () {
    const path = Object.entries(this.dataFilter).map(e => e.join('=')).join('&')
    const token = JSON.parse(sessionStorage.getItem('token') as any).accessToken
    const url = `${Axios.defaults.baseURL}/documents/export/excel?${path}&token=${token}`
    const a = document.createElement('a')
    a.href = url
    a.click()
  }

  onSendEmail (data: any) {
    if (data.to.length === 0) return
    this.loading = true
    this.toggleEmail = false
    Axios.post('/documents/send-email', data).then(response => {
      this.loading = false
    }).catch(() => {
      this.loading = false
    })
  }
}
